import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const TermsConditions = () => {
  const { language } = useLanguage();
  const isEnglish = language === 'en';

  const content = {
    en: {
      title: 'Terms & Conditions',
      points: [
        'By using services of Shivpratap Multistate Nagari Co-op. Credit Society, you agree to our rules.',
        'All members must provide correct and true information.',
        'Loans and deposits are subject to approval by the Society.',
        'Members must follow all Society policies.',
        'Interest rates and charges may change as per rules.',
        'The Society can update terms anytime if needed.',
        'Members should read all documents carefully before signing.',
        'Delayed payments may attract penalties.',
        'Services are provided as per applicable laws.',
        'Any dispute will be handled as per legal procedures.'
      ]
    },
    mr: {
      title: 'अटी व शर्ती',
      points: [
        'By using services of Shivpratap Multistate Nagari Co-op. Credit Society, you agree to our rules.',
        'All members must provide correct and true information.',
        'Loans and deposits are subject to approval by the Society.',
        'Members must follow all Society policies.',
        'Interest rates and charges may change as per rules.',
        'The Society can update terms anytime if needed.',
        'Members should read all documents carefully before signing.',
        'Delayed payments may attract penalties.',
        'Services are provided as per applicable laws.',
        'Any dispute will be handled as per legal procedures.'
      ]
    }
  };

  const currentContent = isEnglish ? content.en : content.mr;

  return (
    <div className="bg-gray-50 min-h-screen py-16 mt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-6 sm:p-10">
            <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
              {currentContent.title}
            </h1>
          </div>
          <div className="p-6 sm:p-10">
            <ul className="space-y-6">
              {currentContent.points.map((point, index) => (
                <li key={index} className="flex gap-4">
                  <div className="mt-2 w-2 h-2 rounded-full bg-purple-500 flex-shrink-0"></div>
                  <p className="text-gray-700 leading-relaxed text-lg">{point}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
